import React from 'react';
import { PageStyle } from '../Utils/generalStyles';

// Components
import ManageMembersSection from '../Components/ManageMembers';
import FooterSection from '../Components/Footer';

const ManageMembers = () => (
  <PageStyle>
    <ManageMembersSection />
    <FooterSection />
  </PageStyle>
);

export default ManageMembers;
